module.exports = __webpack_public_path__ + "assets/bd73413ca2e9edf0253f6f8b9136213e.mp3";